export default "__VITE_ASSET__B6_rO4Ip__"